export default {
  state() {
    return {
      userId: null,
      totalItems: null,
      totalAmount: null,
      products: []
    }
  }
};
